import { render, staticRenderFns } from "./AvailableProducts.vue?vue&type=template&id=55e4bb59&scoped=true&"
import script from "./AvailableProducts.vue?vue&type=script&lang=js&"
export * from "./AvailableProducts.vue?vue&type=script&lang=js&"
import style0 from "./AvailableProducts.vue?vue&type=style&index=0&id=55e4bb59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e4bb59",
  null
  
)

export default component.exports